export default __webpack_public_path__ + "media/images/backgrounds/bg-11-1920x660-53d7ed3b130d6114de7558fad16a69d2.jpg";